import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const InputTag = styled.input`
  ${(props) => (props.className === 'page' && css`
    width: 80px;
    height: 50%;
    text-align: center;
    font-size: 18px;
    color: #333;
  `)}

  ${(props) => props.className === 'progress' && css`
    ${props.video ? css`
      width: 384px;
      height: 12px;
      border-radius: 6px;
    ` : css`
      width: 560px;
      height: 17px;
      border-radius: 8px;

      ${props.page && css`
        width: 432px;
        height: 21px;
        border-radius: 11px;
      `}
    `}
    
    background: ${(props) => css`linear-gradient(to right, rgb(84, 147, 252) ${isNaN(props.value) ? 0 : props.value}%, rgb(213, 213, 213) ${isNaN(props.value) ? 0 : props.value}%)`};

    &::-webkit-slider-runnable-track {
      ${props.video ? css`
        width: 384px;
        height: 12px;
        border-radius: 6px;
      ` : css`
        width: 560px;
        height: 17px;
        border-radius: 8px;
      `}
    }

    &:focus {
      outline-color: #333;
    }

    &::-webkit-slider-thumb {
      
      ${props.video ? css`
        width: 43px;
        height: 44px;
        -webkit-appearance: none;
        appearance: none;
        transform: translateY(calc(-50% + 12px * 0.5));
        background: transparent url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_progressbar_ball.png) right center / contain no-repeat;
      ` : css`
        width: 50px;
        height:52px;
        -webkit-appearance: none;
        appearance: none;
        transform: translateY(calc(-50% + 21px * 0.5));
        background: transparent url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_progressbar_ball.png) right center / cover;
      `}
    }
  `}
`;

export const Input = (props) => {
  return (
    <InputTag 
      type={props.type} 
      name={props.name} 
      value={props.value}
      defaultValue={props.defaultValue} 
      onKeyDown={props.onKeyDown}
      onChange={props.onChange}
      className={props.className}
      video={props.video}
      page={props.page}
    />
  );
};

Input.propTypes = {
  type : PropTypes.string.isRequired,
  name : PropTypes.string.isRequired,
  value : PropTypes.string,
  defaultValue : PropTypes.string,
  className : PropTypes.string
};